import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { SHORT_TERM_RENTAL_TYPE_AIRBNB } from 'lumen/utils/constants/market-insight-constants';

export default class MiAlternativeLodgingService extends Service {
  @tracked supportedAlternativeLodgingTypesForDestination = null;

  get isAltLodgingAirBnbSupported() {
    return (
      this.supportedAlternativeLodgingTypesForDestination &&
      this.supportedAlternativeLodgingTypesForDestination.includes(
        SHORT_TERM_RENTAL_TYPE_AIRBNB,
      )
    );
  }

  // Will be called when leaving the route/switching hotels
  clearValues() {
    this.supportedAlternativeLodgingTypesForDestination = null;
  }

  setSupportedTypesForCurrentDestination(supportedAltLodgingTypes) {
    this.supportedAlternativeLodgingTypesForDestination =
      supportedAltLodgingTypes;
  }
}
